<template>
  <v-container>
    <v-btn
      class="ml-8"
      color="secondary"
      to="/admin/jamaah/list"
    >
      <v-icon left>
        mdi-arrow-left
      </v-icon>
      Kembali
    </v-btn>
    <form class="pa-4" v-on:keyup.enter="submit">
      <v-card flat outlined class="ma-4">
        <v-toolbar flat color="primary white--text">
          <v-toolbar-title>Kepala Keluarga</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row no-gutters>
            <v-col>
              <v-text-field
                outlined
                v-model.trim="$v.jamaah.name.$model"
                label="Nama"
                :error-messages="nameError"
              ></v-text-field>
            </v-col>
            <v-col class="ml-3">
              <v-text-field
                outlined
                v-model.trim="$v.jamaah.address.$model"
                :error-messages="addressError"
                label="Alamat"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col>
              <v-menu
                v-model="menu[0]"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      !jamaah.birthdate ? '' : formatDate(jamaah.birthdate)
                    "
                    outlined
                    clearable
                    label="Tanggal Lahir"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="jamaah.birthdate = null"
                    :error-messages="birthdateError"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model.trim="$v.jamaah.birthdate.$model"
                  :max="new Date().toISOString().substr(0, 10)"
                  no-title
                  @change="closeAndUpdateAge(0)"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="ml-3">
              <v-text-field
                outlined
                v-model="jamaah.age"
                readonly
                type="number"
                label="Umur"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col class="mr-3">
              <v-text-field
                outlined
                v-model.trim="$v.jamaah.phone_number.$model"
                :error-messages="phoneError"
                hint="Gunakan format +628XXXXXXXX"
                label="Nomor HP"
                type="number"
                prefix="+62"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                v-model.trim="$v.jamaah.occupation.$model"
                :error-messages="occupationError"
                label="Pekerjaan"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col class="mr-3">
              <v-select
                :items="status.salary ? status.salary : []"
                label="Penghasilan"
                item-text="description"
                item-value="status_uid"
                v-model="jamaah.salary_id"
                outlined
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                :items="status.family ? status.family : []"
                label="Status Keluarga"
                item-text="description"
                item-value="status_uid"
                v-model.trim="$v.jamaah.family_status_id.$model"
                :error-messages="famStatusError"
                outlined
              ></v-select>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col class="mr-3">
              <v-select
                :items="['Menetap', 'Sementara']"
                outlined
                v-model.trim="$v.jamaah.status_mukim.$model"
                :error-messages="mukimError"
                label="Status Mukim"
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                v-model="jamaah.additional_info.keahlian_khusus"
                label="Keahlian Khusus"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- MEMBER -->
      <v-card
        v-for="(member, index) in members"
        :key="index"
        flat
        outlined
        class="ma-4"
      >
        <v-toolbar flat color="primary white--text">
          <v-toolbar-title>Anggota {{ index + 1 }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row no-gutters class="mt-0">
            <v-col>
              <v-text-field
                outlined
                v-model="members[index].name"
                label="Nama"
                :rules="notEmptyRule"
              ></v-text-field>
            </v-col>
            <v-col class="ml-3">
              <v-menu
                v-model="menu[index + 1]"
                :close-on-content-click="false"
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="
                      !members[index].birthdate
                        ? ''
                        : formatDate(members[index].birthdate)
                    "
                    outlined
                    clearable
                    label="Tanggal Lahir"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="members[index].birthdate = null"
                    :rules="notEmptyRule"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="members[index].birthdate"
                  :max="new Date().toISOString().substr(0, 10)"
                  no-title
                  @change="closeAndUpdateAge(index + 1)"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col>
              <v-text-field
                outlined
                v-model="members[index].age"
                type="number"
                label="Umur"
              ></v-text-field>
            </v-col>
            <v-col class="ml-3">
              <v-text-field
                outlined
                v-model="members[index].phone_number"
                hint="Gunakan format +628XXXXXXXX"
                type="number"
                label="Nomor HP"
                prefix="+62"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col>
              <v-text-field
                :rules="notEmptyRule"
                outlined
                v-model="members[index].occupation"
                label="Pekerjaan"
              ></v-text-field>
            </v-col>
            <v-col class="ml-3">
              <v-select
                :items="status.salary ? status.salary : []"
                label="Penghasilan"
                item-text="description"
                item-value="status_uid"
                v-model="members[index].salary_id"
                outlined
              ></v-select>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-0">
            <v-col>
              <v-select
                :rules="notEmptyRule"
                :items="status.family ? status.family : []"
                label="Status Keluarga"
                item-text="description"
                item-value="status_uid"
                v-model="members[index].family_status_id"
                outlined
              ></v-select>
            </v-col>
            <v-col class="ml-3">
              <v-select
                :rules="notEmptyRule"
                :items="['Menetap', 'Sementara']"
                outlined
                v-model="members[index].additional_info.status_mukim"
                label="Status Mukim"
              ></v-select>
            </v-col>
          </v-row>

          <v-text-field
            outlined
            v-model="members[index].additional_info.keahlian_khusus"
            label="Keahlian Khusus"
          ></v-text-field>
        </v-card-text>
      </v-card>
      <v-btn class="ma-4" @click="addMember" color="primary">
        Tambahkan Anggota
      </v-btn>
      <v-btn class="ma-4" @click="removeMember" color="accent">
        Hapus Anggota
      </v-btn>
      <v-card flat outlined class="ma-4">
        <v-toolbar flat color="primary white--text">
          <v-toolbar-title>Aktivitas</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            outlined
            v-model="jamaah.additional_info.sholat"
            label="Sholat"
          ></v-text-field>
          <v-text-field
            outlined
            v-model="jamaah.additional_info.zakat"
            label="Zakat"
          ></v-text-field>
          <v-text-field
            outlined
            v-model="jamaah.additional_info.pengajian"
            label="Pengajian"
          ></v-text-field>
          <v-text-field
            outlined
            v-model="jamaah.additional_info.catatan"
            label="Catatan"
          ></v-text-field>
        </v-card-text>
      </v-card>
      <v-btn @click="submitJamaah" color="primary" class="ml-4 mt-3">
        Submit!
        <v-progress-circular
          v-if="this.isSubmitLoading == true"
          class="ml-2"
          indeterminate
          color="secondary"
          size="16"
          width="2"
        ></v-progress-circular>
      </v-btn>

      <p v-if="isFormError" class="mt-2 red--text text-caption error-caption">
        "Manusia memang sering melakukan kesalahan, tapi yang terpenting adalah
        bagaimana kita memperbaikinya" <br />
        -Admin
      </p>

      <v-dialog v-model="dialog" max-width="290">
        <v-card>
          <v-card-title class="headline"> Info </v-card-title>

          <v-card-text>
            {{ dialogMessage }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" text @click="dialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <p v-if="isSubmitSuccess" class="mt-2 red--text text-caption error-caption">
        Maaf, terjadi kesalahan saat update data, mohon ulangi update
        kembali. ^^
      </p>
    </form>
  </v-container>
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      paramsJamaah: "",
      jamaahDetails: {},
      isSubmitLoading: false,
      isSubmitSuccess: false,
      date: [],
      jamaah: {
        name: "",
        address: "",
        birthdate: "",
        phone_number: "",
        occupation: "",
        family_status_id: "",
        status_mukim: "",
        salary_id: "",
        additional_info: {},
      },
      members: [],
      menu: [false],
      notEmptyRule: [(v) => !!v || "Kolom ini tidak boleh kosong"],
      dialog: false,
      dialogMessage: "",
      status: {},
      isFormError: false
    };
  },
  validations: {
    jamaah: {
      name: {
        required,
        minLength: minLength(3)
      },
      address: {
        required,
        minLength: minLength(5)
      },
      birthdate: {
        required
      },
      phone_number: {
        minLength: minLength(11),
        maxLength: maxLength(15)
      },
      occupation: {
        required,
        minLength: minLength(2)
      },
      family_status_id: {
        required
      },
      status_mukim: {
        required
      }
    }
  },
  computed: {
    jamaahDetail() {
      return this.jamaahDetails
    },
    nameError() {
      const errors = []
      if (!this.$v.jamaah.name.$dirty) return errors
      !this.$v.jamaah.name.minLength && errors.push("Nama minimal 3 digit")
      !this.$v.jamaah.name.required && errors.push("Nama tidak boleh kosong")
      return errors
    },
    addressError() {
      const errors = []
      if (!this.$v.jamaah.address.$dirty) return errors
      !this.$v.jamaah.address.minLength && errors.push("Alamat minimal 5 digit")
      !this.$v.jamaah.address.required && errors.push("Alamat tidak boleh kosong")
      return errors
    },
    birthdateError() {
      const errors = []
      if (!this.$v.jamaah.birthdate.$dirty) return errors
      !this.$v.jamaah.birthdate.required && errors.push("Tanggal lahir tidak boleh kosong")
      return errors
    },
    phoneError() {
      const errors = []
      if (!this.$v.jamaah.phone_number.$dirty) return errors
      !this.$v.jamaah.phone_number.minLength && errors.push("Nomor HP minimal 11 digit")
      !this.$v.jamaah.phone_number.maxLength && errors.push("Nomor HP maksimal 15 digit")
      return errors
    },
    occupationError() {
      const errors = []
      if (!this.$v.jamaah.occupation.$dirty) return errors
      !this.$v.jamaah.occupation.minLength && errors.push("Pekerjaan minimal 2 digit")
      !this.$v.jamaah.occupation.required && errors.push("Pekerjaan tidak boleh kosong")
      return errors
    },
    famStatusError() {
      const errors = []
      if (!this.$v.jamaah.family_status_id.$dirty) return errors
      !this.$v.jamaah.family_status_id.required && errors.push("Status keluarga tidak boleh kosong")
      return errors
    },
    mukimError() {
      const errors = []
      if (!this.$v.jamaah.status_mukim.$dirty) return errors
      !this.$v.jamaah.status_mukim.required && errors.push("Status mukim tidak boleh kosong")
      return errors
    }
  },
  watch: {
    jamaahDetail() {
      this.jamaah.name = this.jamaahDetail.name
      this.jamaah.address = this.jamaahDetail.address
      this.jamaah.birthdate = this.jamaahDetail.birthdate,
      this.jamaah.phone_number = this.jamaahDetail.phone_number,
      this.jamaah.occupation =  this.jamaahDetail.occupation,
      this.jamaah.family_status_id = this.jamaahDetail.family_status_id,
      this.jamaah.status_mukim = this.jamaahDetail.status_mukim,
      this.jamaah.salary_id = this.jamaahDetail.salary_id,
      this.jamaah.age = this.jamaahDetail.age
    }
  },
  async created() {
    await this.getStatus();
    if(this.$route.params.id) {
      this.paramsJamaah = this.$route.params.id
      // console.log(this.paramsJamaah, 'params')
      this.axios(`/jamaah/detail/${this.$route.params.id}`)
      .then((response) => {
        this.jamaahDetails = response.data.data
        console.log(this.jamaahDetails, 'jamaah details')
      })
      .catch((error) => {
        console.log(error)
      })
    }
  },
  methods: {
    getStatus() {
      this.axios
        .get("/jamaah/status")
        .then((response) => {
          this.status = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    submitJamaah() {
      this.jamaah.masjid_uid = this.$store.getters.getMasjid;
      this.jamaah.members = this.members;
      this.isSubmitLoading = true;
      this.$v.$touch()
      if (this.$v.jamaah.$invalid) {
        this.isFormError = true
        this.isSubmitLoading = false
      }else{
        this.isFormError = false
        //sebelum dimasukan phone number depannya tambah 62
        if(this.jamaah.phone_number != null || this.jamaah.phone_number != "") {
          let nomor = "62" + this.jamaah.phone_number
          this.jamaah.phone_number = nomor
        }
        if(this.members.length > 0) {
          for(let i = 0; i < this.members.length; i++) {
            let hp = ""
            if(this.members[i].phone_number != null || this.members[i].phone_number != "") {
              hp = "62" + this.members[i].phone_number
              this.members[i].phone_number = hp
            }
          }
        }

        this.axios
          .post("/jamaah", this.jamaah)
          .then((response) => {
            console.log(response);
            if (response.data.status) {
              this.isSubmitSuccess = true;
              this.isSubmitLoading = false;
              this.dialogMessage = "Submit sukses!";
              this.dialog = true;
              this.isFormError = false
              this.clear();
              //reset validation
              this.$v.$reset()
            } else {
              this.isSubmitLoading = false;
              this.dialogMessage = "Submit gagal... \n";
              this.dialog = true;
            }
          })
          .catch((error) => {
            console.log(error);
            this.isSubmitLoading = false;
            this.dialogMessage = "Submit gagal... \n" + error;
            this.dialog = true;
          });
      }
      
    },
    addMember() {
      this.members.push({
        additional_info: {},
      });
      this.menu.push(false);
      console.log(this.members);
    },
    removeMember() {
      this.members.pop();
      this.menu.pop();
      console.log(this.members);
    },
    formatDate(targetDate) {
      return this.$moment(targetDate).format("D MMMM YYYY");
    },
    closeAndUpdateAge(idx) {
      if (this.jamaah.birthdate != null) {
        this.jamaah.age = this.$moment().diff(
          this.$moment(this.jamaah.birthdate),
          "years"
        );
      }
      // console.log(this.jamaah);

      if (this.members.length > 0) {
        for (var i = 0; i < this.members.length; i++) {
          if (this.members[i].birthdate != null) {
            this.members[i].age = this.$moment().diff(
              this.$moment(this.members[i].birthdate),
              "years"
            );
          }
        }
        console.log(this.members);
      }
      this.menu[idx] = false;
    },
    clear() {
      //reset field
      this.jamaah = { 
        name: "",
        address: "",
        birthdate: "",
        phone_number: "",
        occupation: "",
        family_status_id: "",
        status_mukim: "",
        additional_info: {} 
      };
      this.members = [];
      window.scrollTo(0, 0);
    },
  },
};
</script>
